module.exports = __webpack_public_path__ + "img/MC7.de73615b.webp";